// extracted by mini-css-extract-plugin
export default {"container":"DialogCodeConfirm_container__gBmxa"};